import { APIEvent } from '../events/apiEvent'
import { StatusBarEvent } from '../events/statusBarEvent'
import { EventBus } from '../event-bus'

export default {
  data () {
    return {
      searchDeviceID: '',
      tenantSelection: null
    }
  },
  mounted: function () {
    if (window.localStorage.getItem('token') === null) {
      this.$store.dispatch(APIEvent.LOGOUT, {})
    }
  },
  computed: {
    tenants () {
      return this.$store.state.tenantsList
    }
  },
  methods: {
    assignTenant: function () {
      if (this.isValid()) {
        let options = {}
        options.action = '1'
        options.leakbot_id = this.searchDeviceID
        options.tenant_id = this.tenantSelection.id
        this.$store.dispatch(APIEvent.UPDATE_DEVICE, options)
          .then((res) => {
            if (res.data.ack) {
              EventBus.$emit(StatusBarEvent.SUCCESS,
                'Device assigned to tenant successfully')
            }
          })
          .catch(this.handleError)
      }
    },
    isValid: function () {
      let valid = true
      let message = ''
      if (this.searchDeviceID === '') {
        message = 'Device ID is required'
        valid = false
      } else if (this.searchDeviceID.length < 6) {
        message = 'Please enter a Device ID in the format XXXXXX'
        valid = false
      } else if (this.tenantSelection === null) {
        message = 'Please select a tenant'
        valid = false
      }
      if (!valid) {
        this.showValidationWarning(message)
      }
      return valid
    },
    showValidationWarning: function (message) {
      EventBus.$emit(StatusBarEvent.WARNING, message)
    },
    handleError (error) {
      let message = error.message
      switch (error.error) {
        case 205:
          message = 'Device ID is missing'
          break
        case 209:
          message = 'Device ID is not in the expected format'
          break
        case 305:
          // Device is not in DB
          message = 'No matches found'
          break
      }
      error.message = message
      EventBus.$emit(StatusBarEvent.ERROR, error.message)
    }
  }
}
